// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"GeneralModal_modalBody_18Mq7","modalHead":"GeneralModal_modalHead_2E7kf","modalFooter":"GeneralModal_modalFooter_38CEi","confirmBtn":"GeneralModal_confirmBtn_3t9cX"};